export const DKIM_PROVIDER_GODADDY_ID = 1;
export const DKIM_PROVIDER_BLUEHOST_ID = 2;
export const DKIM_PROVIDER_HOSTGATOR_ID = 3;
export const DKIM_PROVIDER_DREAMHOST_ID = 4;
export const DKIM_PROVIDER_LIQUIDWEB_ID = 5;
export const DKIM_PROVIDER_INMOTION_ID = 6;
export const DKIM_PROVIDER_OTHER_ID = 7;

export const EMAIL_AUTH_TYPE_LEGACY = 'LEGACY';
export const EMAIL_AUTH_TYPE_SPF = 'SPF';
export const EMAIL_AUTH_TYPE_S1 = 'S1';
export const EMAIL_AUTH_TYPE_S2 = 'S2';
export const EMAIL_AUTH_TYPE_DMARC = 'DMARC';

export const REQUIRED_RECORD_TYPES = [EMAIL_AUTH_TYPE_SPF, EMAIL_AUTH_TYPE_S1, EMAIL_AUTH_TYPE_S2, EMAIL_AUTH_TYPE_DMARC];
